module.exports = __webpack_public_path__ + "static/img/暴雪.0796ef94.svg";